import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const NewReportPage = lazy(() => import('../pages/NewReportPage'));
const ReportTripAndStopPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopPage'));
const ReportTripAndStopDetailsPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopDetailsPage'));
const ReportTripAndStopDailyPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopDailyPage'));
const ReportFleetSafetyPage = lazy(() => import('../modules/FleetSafetyReportPage'));
const ReportSafetyEventsPage = lazy(() => import('../modules/SafetyEventsReportPage'));
const ReportVehicleDeviceAssociationPage = lazy(() => import('../modules/VehicleDeviceAssociationPage/VehicleDeviceAssociationPage'));
const IdentifierAssociationReportPage = lazy(() => import('../modules/IdentifierAssociationReportPage/IdentifierAssociationReportPage'));
const ReportsHomePage = lazy(() => import('../pages/ReportsHomePage'));
const CustomDashboardsPage = lazy(() => import('../pages/CustomDashboardsPage'));
const CustomDashboardDetailsPage = lazy(() => import('../pages/CustomDashboardDetailsPage'));

// Use dynamic import with promise for components that don't have default exports
const OutOfWorkJourneyPage = lazy(() =>
  import('../containers/OutOfWorkJourneyContainer').then((module) => ({
    default: module.OutOfWorkJourneyContainer,
  }))
);

const PointsReportPage = lazy(() =>
  import('../modules/PointsReportPage/PointsReportPage').then((module) => ({
    default: module.PointsReportPage,
  }))
);

const ProductivityReportPage = lazy(() =>
  import('../containers/ProductivityReportContainer').then((module) => ({
    default: module.ProductivityReportContainer,
  }))
);

const DistanceDrivenReportPage = lazy(() =>
  import('../containers/DistanceDrivenReportContainer').then((module) => ({
    default: module.DistanceDrivenReportContainer,
  }))
);

const IdleEngineReportPage = lazy(() =>
  import('../modules/IdleEngineReportPage/IdleEngineReportPage').then((module) => ({
    default: module.IdleEngineReportPage,
  }))
);

const GeofenceEventsReportPage = lazy(() =>
  import('../modules/GeofenceEventsReportPage/GeofenceEventsReportPage').then((module) => ({
    default: module.GeofenceEventsReportPage,
  }))
);

const IncidentReportPage = lazy(() => import('../modules/IncidentReportPage/IncidentReportPage'));

const DriverVehicleAssociationReportPage = lazy(() =>
  import('../modules/DriverVehicleAssociationReportPage/DriverVehicleAssociationReportPage').then((module) => ({
    default: module.DriverVehicleAssociationReportPage,
  }))
);

const routes = [
  {
    path: Location.REPORTS_NEW,
    component: NewReportPage,
    routes: [
      {
        title: 'Relatórios',
        path: Location.REPORTS_HOME,
        exact: true,
        component: ReportsHomePage,
      },
      {
        title: 'Dashboards Personalizados',
        path: Location.REPORTS_CUSTOM_DASHBOARDS,
        exact: true,
        component: CustomDashboardsPage,
      },
      {
        title: 'Dashboard Personalizado',
        path: Location.REPORTS_CUSTOM_DASHBOARD_DETAILS,
        exact: true,
        component: CustomDashboardDetailsPage,
      },
      {
        title: 'Relatório de trajetos e paradas detalhada',
        path: Location.REPORTS_TRIP_AND_STOP_DETAILS,
        exact: true,
        component: ReportTripAndStopDetailsPage,
      },
      {
        title: 'Relatório de trajetos e paradas diário',
        exact: true,
        path: Location.REPORTS_TRIP_AND_STOP_DAILY,
        component: ReportTripAndStopDailyPage,
      },
      {
        title: 'Relatório de trajetos e paradas',
        path: Location.REPORTS_TRIP_AND_STOP_TYPE,
        exact: true,
        component: ReportTripAndStopPage,
      },
      {
        title: 'Relatório de eventos de segurança',
        path: Location.REPORTS_FLEET_SAFETY_TYPE,
        exact: true,
        component: ReportFleetSafetyPage,
      },
      {
        title: 'Relatório de eventos de segurança detalhado',
        path: Location.REPORTS_SAFETY_EVENTS,
        exact: true,
        component: ReportSafetyEventsPage,
      },
      {
        title: 'Relatório de histórico de associações de veículos e dispositivos',
        path: Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION_TYPE,
        exact: true,
        component: ReportVehicleDeviceAssociationPage,
      },
      {
        title: 'Relatório de histórico de associações de veículos e dispositivos',
        path: Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION,
        exact: true,
        component: ReportVehicleDeviceAssociationPage,
      },
      {
        title: 'Relatório de associações de chaveiros',
        path: Location.REPORTS_IDENTIFIER_ASSOCIATION,
        exact: true,
        component: IdentifierAssociationReportPage,
      },
      {
        title: 'Relatório de atividade fora do horário de trabalho',
        path: Location.REPORTS_OUT_JOURNEY,
        exact: true,
        component: OutOfWorkJourneyPage,
      },
      {
        title: 'Relatório ponto a ponto',
        path: Location.REPORTS_ROUTES_POINTS,
        exact: true,
        component: PointsReportPage,
      },
      {
        title: 'Relatório de produtividade',
        path: Location.REPORTS_PRODUCTIVITY,
        exact: true,
        component: ProductivityReportPage,
      },
      {
        title: 'Relatório de distância percorrida',
        path: Location.REPORTS_DISTANCE_DRIVEN,
        exact: true,
        component: DistanceDrivenReportPage,
      },
      {
        title: 'Relatório de motor ocioso',
        path: Location.REPORTS_IDLE_ENGINE,
        exact: true,
        component: IdleEngineReportPage,
      },
      {
        title: 'Relatório de atividade em locais de interesse',
        path: Location.REPORTS_GEOFENCE_EVENTS,
        exact: true,
        component: GeofenceEventsReportPage,
      },
      {
        title: 'Laudo de incidentes',
        path: Location.REPORTS_INCIDENT,
        exact: true,
        component: IncidentReportPage,
      },
      {
        title: 'Relatório de associação motorista - veículo',
        path: Location.REPORTS_DRIVER_VEHICLE_ASSOCIATION,
        exact: true,
        component: DriverVehicleAssociationReportPage,
      },
    ],
  },
];

export default routes;
